import React, { useState, useEffect, useRef } from "react";
import {
  // ArrowDownCircleIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
// import { PDFDownloadLink } from "@react-pdf/renderer";
// import RevisionExistenciaPDF from "../pdf/RevisionExistenciaPDF";
// import Empleado from "./Empleado";

const FiltrosIndex = ({ fetchApi, url, headers, bodegaAsignada, handleOption, handleBuscar, month, handleDate, inputInventario, empleados, setIdEmp, IdBodega, busquedaInvisible, bodegasAsignadas }) => {
  const [bodegas, setBodegas] = useState([]);
  const bodegaRef = useRef();

  const getBodegas = async () => {
    const res = await fetchApi({
      url: url + "/utils/busquedas",
      headers: headers,
      content: {
        opcion: "BODEGAS",
      },
    });
    if(IdBodega == 0){
        setBodegas(res.msg)  
    }else{
      const bodega = bodegasAsignadas // res.msg.filter( element => element.IdBodega === IdBodega)
      setBodegas(bodega);
      //setTimeout(setRefValue, 1000)
    }
  };

  function setRefValue() {
    if(bodegaAsignada){
      bodegaRef.current.value = bodegaAsignada | IdBodega;
    }
  }

  useEffect(() => {
    getBodegas();
  }, []);

  return (
    <>
      <div className="bg-primarioMira px-4 py-5 shadow rounded-lg sm:p-6">
        <div className="lg:grid lg:grid-cols-3 lg:gap-6">
          <div className="lg:col-span-1">
            <h3 className="text-lg font-medium leading-6 text-white">
              Filtros
            </h3>
            <p className="mt-1 text-sm text-grisMira">
              Debe seleccionar la bodega para poder generar las existencias.
            </p>
          </div>
          <div className="mt-5 lg:col-span-2 lg:mt-0">
            <div className="grid grid-cols-8 gap-5">

              <div className="col-span-8 lg:col-span-2"></div>

              <div className="col-span-8 lg:col-span-2">
                {/*
                <label className="block text-sm font-medium text-grisMira">
                  Bodega
                </label>
                <select
                type="text"
                  name="IdPlan"
                  ref={bodegaRef}
                  onChange={(e) => handleOption(e)}
                  //as='select'
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                >
                  {bodegas.map((bodega) => (
                    <option key={bodega.IdBodega} value={bodega.IdBodega}>
                      {bodega.Bodega}
                    </option>
                  ))}
                </select>
                  */}
              </div>

              <div className="col-span-8 lg:col-span-2">
                {/*
                <Empleado
                empleados={empleados}
                setIdEmp={setIdEmp}
                ></Empleado>
                */}
                <label className="block text-sm font-medium text-grisMira">
                  Bodega
                </label>
                <select
                  type="text"
                  name="IdPlan"
                  ref={bodegaRef}
                  onChange={(e) => handleOption(e)}
                  //as='select'
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm bg-gray-100"
                >
                  <option value={0}>--- Seleccione una Bodega ---</option>
                  {bodegas.map((bodega) => (
                    <option key={bodega.IdBodega} value={bodega.IdBodega}>
                      {bodega.Bodega || bodega.NombreBodega}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-span-full lg:col-start-7 lg:col-end-9">
                <div className="flex justify-end pt-6">
                  {busquedaInvisible?null:
                  <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent bg-secundario py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-secundario hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                  onClick={()=>handleBuscar()}
                  >
                    <div className="flex">
                      <MagnifyingGlassIcon
                        className="h-5 w-5 text-white"
                        aria-hidden="true"
                        />
                      <p className="ml-1">Buscar</p>
                    </div>
                  </button>

                      }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FiltrosIndex;
